import { ButtonColor } from "@/common/enum/button-color";
import { ItemSortType } from "@/common/enum/item-sort";
import { Button } from "flowbite-react";
import { useEffect, useRef, useState } from "react";
import { ChevronDownOutlineIcon } from "../icon/ChevronDownOutlineIcon";
import { ChevronUpOutlineIcon } from "../icon/ChevronUpOutlineIcon";
import { Body14Regular } from "../typography/Body14Regular";

interface Props {
  itemSortType: ItemSortType;
  handleSortChange: (sortType: ItemSortType) => void;
}

const itemSortTypes = Object.values(ItemSortType);

const displayNames = {
  [ItemSortType.ALL]: "전체",
  [ItemSortType.CATEGORY_ORDER]: "카테고리순",
  [ItemSortType.SALE_STATUS]: "판매 여부순",
  [ItemSortType.DISPLAY_STATUS]: "진열 여부순",
};

export const ItemSortDropdown: React.FC<Props> = ({
  itemSortType,
  handleSortChange,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative flex gap-[9px]" ref={dropdownRef}>
      <Button
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        color={ButtonColor.WHITE}
        className="w-[348px] border border-semantic-divider"
      >
        <div className="w-[324px] flex items-center justify-between">
          <Body14Regular className="text-semantic-text-secondary">
            {displayNames[itemSortType]}
          </Body14Regular>
          <div className="w-[16px] h-[16px]">
            {open ? <ChevronUpOutlineIcon /> : <ChevronDownOutlineIcon />}
          </div>
        </div>
      </Button>
      {open && (
        <div className="absolute top-[52px] z-40 w-[348px] py-[4px] bg-primary-white border border-semantic-divider rounded-[8px]">
          {itemSortTypes.map((sortType) => (
            <div
              key={sortType}
              className="px-[16px] py-[8px] hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                handleSortChange(sortType);
                setOpen(false);
              }}
            >
              <Body14Regular className="text-semantic-text-secondary">
                {displayNames[sortType]}
              </Body14Regular>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
